import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.less']
})
export class DashboardContainerComponent implements OnInit {
  dashboardId = 0;
  showDashboard = false;
  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((d) => {
      this.showDashboard = true;
      setTimeout(() => {
        this.dashboardId = d.dashboardId;
        this.showDashboard = false;
      }, 10);
    });
  }
}
